/* eslint-disable */
ace.config.setModuleUrl(
  'ace/mode/lucene',
  // eslint-disable-next-line
  require('file-loader!ace-builds/src-min-noconflict/mode-lucene.js')
);
